import React, { useEffect, useMemo, useState } from "react";
import cn from "classnames";
import styles from "./ConsumptionField.module.scss";
import { IConsumptionFieldProps } from "./ConsumptionField.props";
import { useIntl } from "react-intl";
import FieldBage from "@components/global/new/FieldBage/FieldBage";
import { PercentageOutlined } from "@ant-design/icons";
import { InputNumber, Tooltip } from "antd";

export default function ConsumptionField({
  className,
  ...props
}: IConsumptionFieldProps) {
  const { formatMessage } = useIntl();
  const [consumption, setConsumption] = useState<number>(
    Number(props.cons) || 0
  );
  const [err, setErr] = useState<number>(props.err || 0);

  useEffect(() => {
    setErr(props.err || 0);
  }, [props.err]);

  useEffect(() => {
    setConsumption(props.cons || 0);
  }, [props.cons]);

  const errCons = useMemo(() => {
    return Number(((Number(consumption) * err) / 100).toFixed(2));
  }, [err]);

  const consumptionWithErr = useMemo(() => {
    if (!consumption) return 0;

    return Number((consumption + (consumption * err) / 100).toFixed(2));
  }, [consumption, err]);

  const onChange = (v: number) => setConsumption(v);

  useEffect(() => {
    props.onChangeValue(consumptionWithErr);
  }, [consumptionWithErr]);

  //reset
  useEffect(() => {
    if (!props.reset) return;
    setConsumption(props.cons || 0);
  }, [props.reset]);

  return (
    <div className={styles.wrapper}>
      <Tooltip
        trigger={"click"}
        open={props.disabled ? false : undefined}
        title={
          <div className={styles.percent}>
            <InputNumber
              type='number'
              placeholder={formatMessage({ id: "calc.err" })}
              size='small'
              className={styles.percent__field}
              value={!!Number(err) ? err : ""}
              onChange={(v) => setErr(Number(v))}
              controls={false}
              addonAfter='%'
            />
          </div>
        }
        color='white'
      >
        <div
          className={styles.percent_container}
          title={formatMessage({ id: "calc.err" })}
        >
          {err > 0 && <span>{err}</span>}
          <PercentageOutlined style={{ fontSize: 12, color: "red" }} />
        </div>
      </Tooltip>
      <FieldBage
        className={cn(className)}
        name={formatMessage({ id: "calc.cons" })}
        bage={formatMessage({ id: "calc.cons.bage" })}
        disabled={props.disabled}
        up
        defaultValue={consumption}
        oldValue={consumption}
        isError={props.isError}
        id='consumpation'
        hasPrevValue={false}
        getValue={(v) => onChange(Number(v))}
        outlined={props.outlined}
      />
      {errCons > 0 && (
        <p className={styles.calculated}>
          + {errCons} {formatMessage({ id: "calc.cons.bage" })}
        </p>
      )}
      {consumptionWithErr > 0 && err > 0 && (
        <p className={styles.consumptionWithErr}>
          {formatMessage({ id: "calc.perf.err" })} {consumptionWithErr}{" "}
          {formatMessage({ id: "calc.cons.bage" })}
        </p>
      )}
      <input hidden id='err' value={err} />
    </div>
  );
}
